

    export const toMayus = (str) => {
    // Convertimos todo el string a minúsculas primero
    const lowerCaseStr = str.toLowerCase();
  
    // Luego convertimos la primera letra en mayúscula y concatenamos con el resto
    return lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1);
  }
